import { storeToRefs } from 'pinia'
import { useBrandStore } from '@/stores/brand'

/**
 * Ergonomic accessor for the per-host shop brand resolved at app bootstrap.
 *
 * Distinct from `useBranding()` (static Zaveato vs. legacy brand config) — this
 * one is the dynamic per-hostname brand used by the white-label storefront.
 *
 * Components that ONLY need to know "should I hide Zaveato chrome?" should
 * read `isWhiteLabel`. Components that need to render shop branding (logo,
 * theme colour, tagline) should read `brand` directly and tolerate null.
 */
export function useShopBrand() {
  const store = useBrandStore()
  const { brand, isLoaded, isWhiteLabel, hasBrand } = storeToRefs(store)

  return {
    brand,
    isLoaded,
    isWhiteLabel,
    hasBrand,
  }
}
